var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 31.2666V38.2666C39.6667 47.5999 35.9333 51.3333 26.6 51.3333H17.7334C8.40002 51.3333 4.66669 47.5999 4.66669 38.2666V29.3999C4.66669 20.0666 8.40002 16.3333 17.7334 16.3333H24.7334",
    stroke: "#A8ACB3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 31.2666H32.2C26.6 31.2666 24.7333 29.3999 24.7333 23.7999V16.3333L39.6667 31.2666Z",
    stroke: "#A8ACB3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0667 4.66675H36.4",
    stroke: "#A8ACB3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 11.6667C16.3333 7.79341 19.46 4.66675 23.3333 4.66675H29.4466",
    stroke: "#A8ACB3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3333 18.6667V33.1101C51.3333 36.7267 48.3933 39.6667 44.7767 39.6667",
    stroke: "#A8ACB3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3333 18.6667H44.3333C39.0833 18.6667 37.3333 16.9167 37.3333 11.6667V4.66675L51.3333 18.6667Z",
    stroke: "#A8ACB3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFiles);
export default __webpack_public_path__ + "static/media/upload-files.889bc7aa5572f140f7b69ab893a2e931.svg";
export { ForwardRef as ReactComponent };